import { React, useState, useMemo, useEffect, useContext } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { useParams } from "react-router-dom";
import { Tooltip } from "antd";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import DetailInformation from "./NewCompanyInfo";
import ProfileHighlight from "../DetailPage/NewProfileHighlights";
import Funding from "./NewFunding";
import MergerAcquisition from "./NewMA";
import Financials from "../DetailPage/NewFinancials";
import CapTable from "./CapTable";
import SimilarCompanies from "./NewSimilarCos";
import NewsActivity from "./NewNewsActivity";
import { getCompanyDetails } from "../../Config/config";
import { MERGERANDACQUISITION, NEWSLETTER } from "../../Queries/Pe";
import BlankPage from "../BlankPage";
import routePathSegments, { routeNames } from "../../routeSegments";
import FundingDataProvider from "../../Contexts/FundingDataProvider";
import axios from "axios";
import { UserContext } from "../../Contexts/UserContext";
import Tab from "../shared/Tab";
import { debounce, delay } from "lodash";
import { useInView } from "react-intersection-observer";
import { DataFoundContext } from "../../Contexts/DataFoundContext";
import { TableDataContext } from "../../Contexts/TableDataContext";
import { RaiseRequestContext } from "../../Contexts/RaiseRequestContext";
import { PeFilterContext } from "../../Contexts/PeFilterContext";
import { FaFilter } from "react-icons/fa";
/**
 * The CompanyDetail function is a component that displays detailed information about a company,
 * including its overview, funding, mergers and acquisitions, financials, cap table, similar companies,
 * and recent news and activity.
 * It renders the company details including the navigation, profile
 * highlight, funding, mergers & acquisitions, financials, cap table, similar companies, and news
 * activity sections.
 */

const CompanyDetail = ({ menu, section }) => {

   const overview = () => { document.getElementById("profile").scrollIntoView({ behavior: 'smooth' }); }
    const funding = () => { document.getElementById("fund").scrollIntoView({ behavior: 'smooth' }); }
    const merger = () => { document.getElementById("merge").scrollIntoView({ behavior: 'smooth' }); }
    const financial = () => { document.getElementById("financial").scrollIntoView({ behavior: 'smooth' }); }
    const capTable = () => { document.getElementById("cap").scrollIntoView({ behavior: 'smooth' }); }
    const similarCompanies = () => { document.getElementById("similar").scrollIntoView({ behavior: 'smooth' }); }
    const newsActivity = () => { document.getElementById("news").scrollIntoView({ behavior: 'smooth' }); }

  const [isActive, setIsActive] = useState(1);
  const [isLoading, setIsLoading] = useState(true);
  const [isError, setIsError] = useState();
  const [profileData, setProfileData] = useState();
  const {data, setData, tableCompanyId, setNonXBRLFypeConsolidated, setNonXBRLFypeStandalone} = useContext(TableDataContext);
  const { accessControl, open, setOpen } = useContext(PeFilterContext);
  const { getAllowedModules, isDirectoryUser } = useContext(UserContext);
  const { companyId } = useParams();
  const location = useLocation();
  let companyProfileId = parseInt(companyId);
  const [skipScroll, setSkipScroll] = useState(false);
  const {
    capTableDataFound,
    similarCompaniesDataFound, setSimilarCompaniesDataFound,
    newsAndActivityDataFound,
    setNewsAndActivityDataFound
  } = useContext(DataFoundContext);
  const {setCname} = useContext(RaiseRequestContext);

  /* The below code is using the `useInView` hook to track the visibility of certain elements on the
  page. It creates multiple instances of the hook, each with different parameters such as threshold
  and rootMargin. The hook returns two values - the element reference and a boolean value indicating
  whether the element is currently visible in the viewport.  */
  const [overviewEl, isOverviewVisible] = useInView({ threshold: 0.5, rootMargin: "60px 0px 0px 0px", skip: skipScroll })
    const [fundingEl, isfundingVisible] = useInView({ threshold: 0.5, rootMargin: "60px 0px 0px 0px", skip: skipScroll })
    const [mergerEl, ismergerVisible] = useInView({ threshold: 0.5, rootMargin: "60px 0px 0px 0px", skip: skipScroll })
    const [financialEl, isfinancialVisible] = useInView({ threshold: 0.5, rootMargin: "60px 0px 0px 0px", skip: skipScroll })
    const [captableEl, iscaptableVisible] = useInView({ threshold: 0.5, rootMargin: "60px 0px 0px 0px", skip: skipScroll })
    const [similarCompaniesEl, issimilarCompaniesVisible] = useInView({ threshold: 0.5, rootMargin: "60px 0px 0px 0px", skip: skipScroll })
    const [newsEl, isnewsVisible] = useInView({ threshold: 0.5, rootMargin: "60px 0px 0px 0px", skip: skipScroll })    

    const handleNonXBRLFype = (response) => {
      if (!response?.data?.profit_loss) return;

      const types = ['Standalone', 'Consolidated'];
      const result = {};

      types.forEach((type) => {
        const filteredFYs = response.data.profit_loss
          .filter(
            item =>
              item.data_source === "MCA - C2 Automation" &&
              item.fin_type === type
          )
          .map(item => parseInt(item.fy));

        if (filteredFYs.length > 0) {
          const minFY = Math.min(...filteredFYs);
          const maxFY = Math.max(...filteredFYs);

          const fyRange = minFY === maxFY
            ? `FY${minFY}`
            : `FY${minFY} – FY${maxFY}`;

          result[type.toLowerCase()] = fyRange;
        }
      });
      setNonXBRLFypeStandalone(result.standalone || null);
      setNonXBRLFypeConsolidated(result.consolidated || null);
    };

  const getProfile = () => {
    setData([]);
    axios(`${getCompanyDetails}/${companyId}/`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Requested-With": "XMLHttpRequest",
        },
        data: {
          "dealcompany_id": localStorage.getItem("company_id") ? parseInt(localStorage.getItem("company_id")) : null,
          "pe_firm_id": localStorage.getItem("company_id") ? parseInt(localStorage.getItem("company_id")) : null,
          "cfs_firm_id": localStorage.getItem("cfs_company_id") ? parseInt(localStorage.getItem("cfs_company_id")) : null,
          "user_email": localStorage.getItem("LOGGED_IN_EMAIL"),
          "stage_ids": accessControl?.pe_stage?.id,
          "deal_range_usd_min": accessControl?.pe_deal_range?.from,
          "deal_range_usd_max": accessControl?.pe_deal_range?.to,
          "industry_ids": accessControl?.peindustries?.id,
          "country_ids": accessControl?.pe_countries?.id,
          "region_ids": accessControl?.pe_regions?.id,
          "state_ids": accessControl?.pe_states?.id,
          "city_ids": accessControl?.pe_cities?.id,
          "ma_country_ids": accessControl?.ma_countries?.id,
          "ma_region_ids": accessControl?.ma_regions?.id,
          "ma_state_ids": accessControl?.ma_states?.id,
          "ma_city_ids": accessControl?.ma_cities?.id,
          "ma_industry_ids": accessControl?.maindustries?.id,
          "cfs_industry_ids": accessControl?.cfsindustries?.id,
        }
      }
    )
      .then((response) => {
        if (response.data) {
          setIsLoading(false);
          setData(response?.data);
          handleNonXBRLFype(response);
          setProfileData(response?.data.profile);
          if(response.data.related_news?.length !== 0){
            setNewsAndActivityDataFound(true) 
          } else setNewsAndActivityDataFound(false)
          if(response?.data?.similar_cos.length !== 0){
            setSimilarCompaniesDataFound(true)
          }else setSimilarCompaniesDataFound(false)
          setCname(response?.data?.profile?.name);
        }
      })
      .catch(() => {
        setIsError(true);
        setIsLoading(false);
      });
  };

  useEffect(() => {
    getProfile();
  }, [companyId]);

  const onTabClick = (tabIndex) => {
    setSkipScroll(true);
    delay(() => {
      setSkipScroll(false);
    }, 500);
    if (tabIndex === 1) {
      overview();
    } else if (tabIndex === 2) {
      funding();
    } else if (tabIndex === 3) {
      merger();
    } else if (tabIndex === 4) {
      financial();
    } else if (tabIndex === 5) {
      capTable();
    } else if (tabIndex === 6) {
      similarCompanies();
    } else if (tabIndex === 7) {
      newsActivity();
    }

    setIsActive(tabIndex);
  };

  const showSimilarCompanies = useMemo(() => {
    const allowedModules = getAllowedModules();
    return allowedModules.includes("pe") || allowedModules.includes("vc");
  }, [getAllowedModules]);

  const setIsActiveOnScroll = useMemo(() => {
    return debounce((index) => setIsActive(index), 100);
  }, []);

  useEffect(() => {
    if (isOverviewVisible) {
      setIsActiveOnScroll(1);
    } else if (isfundingVisible) {
      setIsActiveOnScroll(2);
    } else if (ismergerVisible) {
      setIsActiveOnScroll(3);
    } else if (isfinancialVisible) {
      setIsActiveOnScroll(4);
    } else if (iscaptableVisible) {
      setIsActiveOnScroll(5);
    } else if (issimilarCompaniesVisible) {
      setIsActiveOnScroll(6);
    } else if (isnewsVisible) {
      setIsActiveOnScroll(7);
    }
  }, [
    isOverviewVisible,
    iscaptableVisible,
    isfinancialVisible,
    isfundingVisible,
    ismergerVisible,
    isnewsVisible,
    issimilarCompaniesVisible,
    setIsActiveOnScroll,
  ]);

  const currentIndex = tableCompanyId?.indexOf(Number(companyId));

  document.title =
    menu == "pe"
      ? `${profileData?.name ? profileData?.name + " -" : " "}  PE-VC Companies - Venture Intelligence`
      : `${profileData?.name ? profileData?.name + " -" : " "}  VC Companies - Venture Intelligence`;

  return isLoading && !isError ? (
    <div className="overflow-x-auto lg:overflow-x-hidden overflow-y-hidden lg:overflow-y-hidden">
      <table className="h-[10rem] w-full bg-[#FFFFFF] ">
        <center>
          <div role="status" className="bg-white  h-[16rem]">
            <svg
              className="relative top-[6rem] inline mr-2 w-12 h-12 text-gray-200 animate-spin dark:text-gray-600 fill-[#CA8A24]"
              viewBox="0 0 100 101"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                fill="currentColor"
              />
              <path
                d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                fill="currentFill"
              />
            </svg>
          </div>
        </center>
      </table>
    </div>
  ) : !isError ? (
    <div id="detail-page" className="overflow-y-auto">
      <div className="bg-[#FFFFFF] relative">
        <nav
          className="flex p-1 lg:px-1 px-3 border-b "
          aria-label="Breadcrumb"
        >
          <ol className="flex items-center space-x-1">
            <li className="flex items-center">
              <div className="flex items-center">
                <NavLink
                  to={
                    location.state?.prevPath != null
                      ? location.state?.prevPath
                      : menu == "vc"
                      ? routeNames.vc_companies_vc_investments
                      : routeNames.pe_companies_pe_vc_investments
                  }
                  className="ml-2 text-[11pt] lg:text-[12px] text-[#666666] font-sans_book_body"
                >
                  Companies
                </NavLink>
              </div>
            </li>
            <li className="flex items-center">
              <div className="flex items-center">
                <span className=" text-[12px] text-[#666666] mr-1">/</span>
                <span className=" text-[11pt] lg:text-[12px] text-[#666666] font-semibold">
                  {profileData?.name}
                </span>
              </div>
            </li>
          </ol>
        </nav>
        {tableCompanyId && (
          <>
                {/* <button
                  className="cursor-pointer absolute top-[0.3rem] right-12 pr-2"
                  onClick={() => setOpen(!open)}
                >
                  <FaFilter color="#bc8b20" size={21} />
                </button> */}
            <Tooltip title="Prev">
              <NavLink
                className="absolute top-2 right-8"
                to={
                  menu === "vc"
                    ? routeNames.vcCompanyFundById(
                        tableCompanyId[currentIndex - 1]
                      )
                    : routeNames.peCompanyFundById(
                        tableCompanyId[currentIndex - 1]
                      )
                }
              >
                {tableCompanyId?.length === 0 || currentIndex === 0 ? null : (
                  <FaChevronLeft size={15} color="grey" />
                )}
              </NavLink>
            </Tooltip>
            <Tooltip title="Next">
              <NavLink
                className="absolute top-2 right-4"
                to={
                  menu === "vc"
                    ? routeNames.vcCompanyFundById(
                        tableCompanyId[currentIndex + 1]
                      )
                    : routeNames.peCompanyFundById(
                        tableCompanyId[currentIndex + 1]
                      )
                }
              >
                {tableCompanyId?.length - 1 === currentIndex ? null : (
                  <FaChevronRight size={15} color="grey" />
                )}
              </NavLink>
            </Tooltip>
          </>
        )}
        <DetailInformation
          data={data}
          id={companyId}
          page="companyPage"
          cname={profileData?.name}
          type={menu}
          section={section}
        />
      </div>

      <div className="bg-[#EDEDED]">
        <div className="flex flex-row overflow-x-auto scrollbar space-x-6 bg-white px-6 pt-1  border-b border-[#D7D7D7] cursor-pointer sticky top-0  custom-z-index scrollbar-remove details-tab ">
            <Tab active={isActive === 1} label={"Overview"} onClick={() => onTabClick(1)} />
            <Tab active={isActive === 2} label={"Funding"} onClick={() => onTabClick(2)} />
            <Tab active={isActive === 3} label={"Mergers & Acquisitions"} onClick={() => onTabClick(3)} />
            <Tab active={isActive === 4} label={"Financials"} onClick={() => onTabClick(4)} />
            {capTableDataFound ? <Tab active={isActive === 5} label={"Cap Table"} onClick={() => onTabClick(5)} /> : ''}
            {similarCompaniesDataFound &&  showSimilarCompanies ? <Tab active={isActive === 6} label={"Similar Companies"} onClick={() => onTabClick(6)} /> : ''}
            {newsAndActivityDataFound ? <Tab active={isActive === 7} label={"Recent News & Activity"} onClick={() => onTabClick(7)} /> : ''}
        </div>
        <div className="h-full space-y-5 sections-items">
          <section ref={overviewEl} className="scroll-mt-14" id="profile">
            <ProfileHighlight profile={profileData} financials={data} menu={menu}/>
          </section>
          <section ref={fundingEl} id="fund" className="scroll-mt-14">
            <FundingDataProvider>
                <Funding
                menu={menu}
                companyName={profileData.name}
                funding={data.private_equity}
                />
            </FundingDataProvider>
            </section>
            <section ref={mergerEl} id="merge" className="scroll-mt-14">
              <MergerAcquisition
                companyName={profileData.name}
                data={data.merger_acquisition}
              />
            </section>
          <section ref={financialEl} className="scroll-mt-14" id="financial">
            <Financials companyName={profileData.name} profile={profileData} data={data} menu={menu} cfsId={data?.cfs_profile?.pk}/>
          </section>
          <section ref={captableEl} className="scroll-mt-14" id="cap">
            <CapTable companyName={profileData?.name} />
          </section>
          {similarCompaniesDataFound && (
            <section
              ref={similarCompaniesEl}
              className="scroll-mt-14"
              id="similar"
            >
              <SimilarCompanies
                companyName={profileData?.name}
                data={data.similar_cos}
                cmpIds={data.similar_cos.map(val => val.id)}
                menu={menu}
              />
            </section>
          )}
          <section ref={newsEl} className="scroll-mt-14" id="news">
            <NewsActivity menu="companydetail" news={data.related_news} />
          </section>
        </div>
      </div>
    </div>
  ) : (
        isError && (
          <div className="w-full h-full flex justify-center items-center">
            <h1>No Data Found for this company</h1>
          </div>
        )
    );
};

export default CompanyDetail;
